'use strict';

/**
 * Events are divided up by name space so only the
 * events that are needed are initialized.
 *
 * The following ignore is included on several lines in the file.
 *
 * // jshint ignore:line
 *
 * This ignore is included to prevent a build warning that
 * dataLayer is not defined. However the dataLayer should already
 * be defined in the DOM by the tag manager module.
 */
var events = {
	account: function () {},
	cartshow: function () {
	    $('body').on('click', '.recommendations .product-tile a', function () {
            var gtmdata = $.parseJSON($(this).attr('data-gtmdata'));
            pushEvent('eventTracker', 'Cart', 'You May Also Like', gtmdata.stylenumber);
		});

	    var masterid;
		$('body').on('click', '.cart-page .remove-product', function () {
            masterid = $(this).attr('data-masterid');
		}).on('click', '.cart-delete-confirmation-btn', function () {
			pushEvent('eventTracker', 'Remove', 'CO Remove Click', masterid);
		});

		// Affirm
		$('body').on('click', 'a.affirm-modal-trigger', function () {
			pushEvent('eventTracker', 'Affirm', 'CO Affirm Cart Learn More Click', 'Cart');
		});

		// Checkout Button
		$('body').on('click', 'a.checkout-btn', function () {
			pushEvent('eventTracker', 'Checkout Button', 'CO Checkout Click', '');
		});

		// Payment Method
		$('body').on('click', '.btn.dw-apple-pay-button', function () {
			pushEvent('eventTracker', 'Payment Method', 'ApplePay Click', 'Cart');
		});
		$('body').on('click', '.checkout-shoprunner button', function () {
			pushEvent('eventTracker', 'Payment Method', 'Shoprunner Click', 'Cart');
		});
		$('body').on('click', '#amazonPayButton', function () {
			pushEvent('eventTracker', 'Payment Method', 'Amazon Pay Click', 'Cart');
		});
		$('body').on('click', '#icForm a', function () {
			pushEvent('eventTracker', 'Payment Method', 'International Check Out Click', 'Cart');
		});

		//Refer a friend at cart
		$('body').on('click', '.mmWrapping', function() {
			pushEvent('eventTracker', 'Refer A Friend', 'CO Refer A Friend Click', '');
		});
	},
	checkoutbegin: function () {
		// Continue As Guest
		$('body').on('click', '.checkout-login-form .continue-as-guest', function () {
			pushEvent('eventTracker', 'Continue As Guest', 'CO Continue As Guest Click', '');
		});

		// Sign In
		$('body').on('click', '.checkout-login-form .btn-sign-in', function () {
			pushEvent('eventTracker', 'Sign In', 'CO Sign In Click', '');
		});
		$('body').on('click', '.checkout-login-form #password-reset', function () {
			pushEvent('eventTracker', 'Sign In', 'CO Forgot Your Password Click', '');
		});

		// Make This A Gift
		$('body').on('click', '.gift-message-block .is-gift-reveal label', function () {
			pushEvent('eventTracker', 'Make This A Gift', 'CO Make This A Gift Click', '');
		});
		$('body').on('click', '.gift-message-block .is-gift-fields label', function () {
			pushEvent('eventTracker', 'Make This A Gift', 'CO Do Not Include Prices Check', '');
		});

		// Edit Bag
		$('body').on('click', '.order-product-summary .checkout-edit-bag', function () {
			pushEvent('eventTracker', 'Edit Bag', 'CO Edit Bag Click', '');
		});

		// Contact Us
		$('body').on('click', '.checkout-need-help-container .checkout-need-help a', function () {
			pushEvent('eventTracker', 'Contact Us', 'CO Phone Number Click', '');
		});

		// Edit at Check Out
		$('body').on('click', '.shipping-summary .edit-button', function () {
			pushEvent('eventTracker', 'Edit at Check Out', 'CO Edit Shipping Click', '');
		});
		$('body').on('click', '.payment-summary .edit-button', function () {
			pushEvent('eventTracker', 'Edit at Check Out', 'CO Edit Payment Click', '');
		});

		// Payment Method	
		$('body').on('click', '.gift-card-control label', function () {
			pushEvent('eventTracker', 'Payment Method', 'Gift Card Check', 'Checkout');
		});
		$('body').on('click', '.nav-link.credit-card-tab', function () {
			pushEvent('eventTracker', 'Payment Method', 'Credit Card Click', 'Checkout');
		});
		$('body').on('click', '.nav-link.paypal-tab', function () {
			pushEvent('eventTracker', 'Payment Method', 'Paypal Click', 'Checkout');
		});
		$('body').on('click', '.nav-link.affirm-payment-tab', function () {
			pushEvent('eventTracker', 'Payment Method', 'Affirm Click', 'Checkout');
		});

		//Sign-in link at shipping
		$('body').on('click', '.checkout-sign-in-out-container a', function() {
			pushEvent('eventTracker', 'Sign In', 'CO Shipping Sign In Click', '');
		});
	},
	productshow: function () {
		// Product Selection
		$('body').on('click', '.color-container a', function () {
			if ($(this).hasClass('selectable')) {
				var productId = $('.product-detail').attr('data-pid');
				var newproductId = $(this).attr('data-stylenumber');
				pushEvent('eventTracker', 'Product Selection', 'PDP Color Click', productId + ' - ' + newproductId);
			}
		});
		$('body').on('click', '.width-container a', function () {
			var productId = $('.product-detail').attr('data-pid');
			var width = $(this).attr('data-attr-value');
			if ($(this).hasClass('selectable')) {
				pushEvent('eventTracker', 'Product Selection', 'PDP Width Click', productId + ' - ' + width);
			} else {
				var size = $('.size-container a.selected').attr('data-attr-value');
				pushEvent('eventTracker', 'Error', 'Out of Stock Error', productId + ' - ' + width + ' - ' + size);
			}
		});
		$('body').on('click', '.size-container a', function () {
			var productId = $('.product-detail').attr('data-pid');
			var size = $(this).attr('data-attr-value');
			if ($(this).hasClass('selectable')) {
				pushEvent('eventTracker', 'Product Selection', 'PDP Size Click', productId + ' - ' + size);
			} else {
				var width = $('.width-container a.selected').attr('data-attr-value');
				if (typeof width != "undefined") {
					pushEvent('eventTracker', 'Error', 'Out of Stock Error', productId + ' - ' + width + ' - ' + size);
				} else {
					pushEvent('eventTracker', 'Error', 'Out of Stock Error', productId + ' - ' + size);
				}
			}
		});

		// Video
		$('body').on('click', 'button.icon-video-carousel', function () {
			var productId = $('.product-detail').attr('data-pid');
	        pushEvent('eventTracker', 'Videos', 'PDP Product Video Play', productId);
		});

		// Reviews
		$('body').on('click', '.accordian .reviews', function () {
			var productId = $('.product-detail').attr('data-pid');
			if ($(this).hasClass('collapsed')) {
				pushEvent('eventTracker', 'Review', 'PDP Review Section Open', productId);
			} else {
				pushEvent('eventTracker', 'Review', 'PDP Review Section Close', productId);
			}
		});
		$('body').on('click', '.TTteaser.scrollTo', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Review', 'PDP Review Click', productId);
		});
		$('body').on('click', '.buy-bar .bb-reviews', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Review', 'Buy Bar Review Click', productId);
		});
		$('body').on('click', '.tt-c-reviews-summary__write-review', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Review', 'PDP Write A Review Click', productId);
		});
		$('body').on('click', '.tt-o-filter__options .tt-o-filter__apply', function () {
			var selectedValues = [];
			$('.tt-o-filter__options .tt-o-button--toggle--is-active').each(function(){
				selectedValues.push($(this).text());
			});
			var values = selectedValues.join('|');
			pushEvent('eventTracker', 'Review', 'PDP Review Filter Click', values);
		});
		$('body').on('click', '.tt-o-menu__list .tt-o-menu__item', function () {
			pushEvent('eventTracker', 'Review', 'PDP Review Sort Click', $(this).text());
		});

		// add to bag
		$('body').on('click', '.prices-add-to-cart-actions button.add-to-cart[data-disabled=false]', function (e, data) {
			if(typeof data === "undefined") {
				var productId = $('.product-detail').attr('data-pid');
				pushEvent('eventTracker', 'Add to Bag', 'PDP Add to Bag Click', productId);
			}
		});

		// Find in Store
		$('body').on('click', '.findinstore-button a', function () {
			if ($(this).attr('data-disabled') == 'false') {
				var productId = $('.product-detail').attr('data-pid');
				pushEvent('eventTracker', 'Find in Store', 'PDP Find in Store Click', productId);
			}
		});
		$('body').on('submit', '#findinstore-form', function () {
			var productId = $('.product-detail').attr('data-pid');
			var zip = $(this).find('input[name=zipcode]').val();
			pushEvent('eventTracker', 'Find in Store', 'PDP Zip Code Entry', productId + ' - ' + zip);
		});

		// CTA's
		$('body').on('click', '.link-to.col-12.text-right a', function () {
			var productId = $('.product-detail').attr('data-pid');
	        pushEvent('eventTracker', 'CTA', 'PDP More Reasons To Love It Click', productId);
		});
		$('body').on('click', '.buy-bar .bb-full-details', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'CTA', 'Buy Bar Details Click', productId);
		});
		$('body').on('click', '.buy-bar .bb-features', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'CTA', 'Buy Bar Features Click', productId);
		});

		// Size Guide
		$('body').on('click', '.size-chart a', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Size Guide', 'PDP Size Guide Link Click', productId);
		});
		$('body').on('click', '.accordian .sizeguide', function () {
			var productId = $('.product-detail').attr('data-pid');
			if ($(this).hasClass('collapsed')) {
				pushEvent('eventTracker', 'Size Guide', 'PDP Size Guide Section Open', productId);
			} else {
				pushEvent('eventTracker', 'Size Guide', 'PDP Size Guide Section Close', productId);
			}
		});

		//shoprunner-container
		$('body').on('click', '.shoprunner-container .srd_a', function(){
			var productId = $('.product-detail').attr('data-pid');
			if ($(this).index() == 0) {
				pushEvent('eventTracker', 'Shoprunner', 'PDP Shoprunner Learn More', productId);
			} else {
				pushEvent('eventTracker', 'Shoprunner', 'PDP Shoprunner Login', productId);
			}
		});
		
		// Q&A
		$('body').on('click', '.accordian .questions', function () {
			var productId = $('.product-detail').attr('data-pid');
			if ($(this).hasClass('collapsed')) {
				pushEvent('eventTracker', 'Q&A', 'PDP Q&A Section Open', productId);
			} else {
				pushEvent('eventTracker', 'Q&A', 'PDP Q&A Section Close', productId);
			}
		});

		//Social Media
		$('body').on('click', '.accordian .share', function () {
			var productId = $('.product-detail').attr('data-pid');
			if ($(this).hasClass('collapsed')) {
				pushEvent('eventTracker', 'Social Media', 'PDP Share Section Open', productId);
			} else {
				pushEvent('eventTracker', 'Social Media', 'PDP Share Section Close', productId);
			}
		});
		$('body').on('click', '#share a.twitter', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Social Media', 'PDP Twitter Click', productId);
		});
		$('body').on('click', '#share a.facebook', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Social Media', 'PDP Facebook Click', productId);
		});
		$('body').on('click', '#share a.pinterest', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Social Media', 'PDP Pinterest Click', productId);
		});

		// Recommendations
	    $('body').on('click', '.recommendations .product-tile a', function () {
	        var gtmdata = $.parseJSON($(this).attr('data-gtmdata'));
	        pushEvent('eventTracker', 'Our Picks for You', 'PDP Image Click', gtmdata.stylenumber);
		});

		// Affirm
		$('body').on('click', '.affirm-modal-trigger', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Affirm', 'PDP Affirm Click', productId);
		});

		// True Fit
		$('body').on('click', 'button.tfc-cfg-basic-button', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'TrueFit', 'PDP TrueFit Click', productId);
		});

		// Smart Gift
		$('body').on('click', '.smgt-cta a', function () {
			var productId = $('.product-detail').attr('data-pid');
			pushEvent('eventTracker', 'Smart Gift', 'PDP Smart Gift Click', productId);
		});
	},
	searchshow: function () {
		// Search Results
		if ($('.grid-header .search-keywords').length > 0) {
			var query = $('.grid-header .search-keywords').attr('data-query');
			var count = $('.grid-header .search-count').attr('data-count');
			pushEvent('eventTracker', 'Search Results', 'Page View', query + ' - ' + count);
		}
		if ($('.no-search-results .search-keywords').length > 0) {
			var query = $('.no-search-results .search-keywords').attr('data-query');
			pushEvent('eventTracker', 'Search Results', 'Page View', query + ' - 0');
		}

		// Product Selection
		$('body').on('click', '.color-container a', function () {
			var productId = $('.product-detail').attr('data-pid');
			var newproductId = $(this).attr('data-stylenumber');
			pushEvent('eventTracker', 'Product Selection', 'QS Color Click', productId + ' - ' + newproductId);
		});
		$('body').on('click', '.width-container a', function () {
			var productId = $('.product-detail').attr('data-pid');
			var attr = $(this).attr('data-attr-value');
			pushEvent('eventTracker', 'Product Selection', 'QS Width Click', productId + ' - ' + attr);
		});
		$('body').on('click', '.size-container a', function () {
			var productId = $('.product-detail').attr('data-pid');
			var attr = $(this).attr('data-attr-value');
			pushEvent('eventTracker', 'Product Selection', 'QS Size Click', productId + ' - ' + attr);
		});
		
		// Add to Bag
		$('body').on('click', 'button.add-to-cart-global[data-disabled=false]', function () {
			var gtmdata = $.parseJSON($(this).attr('data-gtmdata'));
	        pushEvent('eventTracker', 'Add to Bag', 'QS Add to Bag Click', gtmdata.stylenumber);
		});

		// Grid Page Filters
    	$('.refinement-bar-inner').on('click', '.refinement-category .card-body a', function () {
	        pushEvent('eventTracker', 'Grid Page Filters', 'Category Click', window.location.origin +  $(this).attr('href'));
		});
		/*$('.refinement-bar-inner').on('click', '.refinement-collection .card-body a', function () {
			var text = $(this).text().trim();
	        pushEvent('eventTracker', 'Grid Page Filters', 'Collection Click', text);
		});
		$('.refinement-bar-inner').on('click', '.refinement-style .card-body a', function () {
			var text = $(this).text().trim();
	        pushEvent('eventTracker', 'Grid Page Filters', 'Style Click', text);
		});*/
		$('.refinement-bar-inner').on('click', '.refinement-color .card-body a', function () {
	        pushEvent('eventTracker', 'Grid Page Filters', 'Color Click', window.location.origin +  $(this).attr('href'));
		});
		$('.refinement-bar-inner').on('click', '.refinement-width .card-body a', function () {
	        pushEvent('eventTracker', 'Grid Page Filters', 'Width Click', window.location.origin +  $(this).attr('href'));
		});
		$('.refinement-bar-inner').on('click', '.refinement-size .card-body a', function () {
	        pushEvent('eventTracker', 'Grid Page Filters', 'Size Click', window.location.origin +  $(this).attr('href'));
		});
		$('.refinement-bar-inner').on('click', '.refinement-price .card-body a', function () {
	        pushEvent('eventTracker', 'Grid Page Filters', 'Price Click', window.location.origin +  $(this).attr('href'));
		});
		$('.refinement-bar-inner').on('click', '.refinement-footer a.reset', function () {
			pushEvent('eventTracker', 'Grid Page Filters', 'Clear Filters Click', window.location.origin +  $(this).attr('href'));
		});
		$('.refinement-bar-inner').on('click', '.refinement-footer a.view-results', function () {
			pushEvent('eventTracker', 'Grid Page Filters', 'View Results Click', window.location.origin +  $(this).attr('href'));
		});
		$('body').on('change', '.sort-control .custom-select', function () {
			var text = $(this).find(":selected").text().trim();
	        pushEvent('eventTracker', 'Grid Page Filters', 'Sort Click', text);
		});
		$('body').on('click', '.color-swatches a', function () {
			var gtmdata = $('a.link').data('gtmdata');
			var gender = gtmdata.categoryID.split("/")[0];
			pushEvent('eventTracker', 'Product Color Swatch', 'PLP Color Swatch Click', gtmdata.name + ' + ' + gender);
		});
	},
	orderconfirm: function() {},
	checkoutshow: function() {
		// GE - Continue As Guest
		$('body').on('click', '.checkout-login-form .continue-as-guest', function () {
			pushEvent('eventTracker', 'Continue As Guest', 'CO Continue As Guest Click', '');
		});

		// GE - Sign In
		$('body').on('click', '.checkout-login-form .btn-sign-in', function () {
			pushEvent('eventTracker', 'Sign In', 'CO Sign In Click', '');
		});
	},
	orderdetails: function() {
		// Account - Order Details
		$('body').on('click', '.order-details .return-btn a', function (e) {
			var orderno = $(this).parent().data('orderno');
			pushEvent('eventTracker', 'Account - Order Details', 'Order Details Make A Return Click', orderno);
		});
	},
	orderhistory: function() {
		// Account - Order History
		$('body').on('click', '.order-list-container .view-details a', function (e) {
			pushEvent('eventTracker', 'Account - Order History', 'Order History View Details Click', '');
		});
		$('body').on('click', '.order-list-container .make-return a', function (e) {
			var orderno = $(this).parent().data('orderno');
			pushEvent('eventTracker', 'Account - Order History', 'Order History Make A Return Click', orderno);
		});
	},
	accountprofile: function () {
		// Account - Profile
		$('body').on('click', '.account-profile .profile-card a', function (e) {
			pushEvent('eventTracker', 'Account - Profile', 'Profile Edit Click', '');
		});
		$('body').on('click', '.account-profile .profile-data a', function (e) {
			pushEvent('eventTracker', 'Account - Profile', 'Profile Questionnaire Edit Click', '');
		});
	},
	accountquestionnaire: function () {
		$('body').on('click', '.edit-profile-data-form .select-element.gender', function (e) {
			var selection = $(this).data('value') == '1' ? 'Male' : 'Female';
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Gender Select', selection);
		});
		$('body').on('click', '.edit-profile-data-form .select-element.size', function (e) {
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Size Select', $(this).data('value'));
		});
		$('body').on('click', '.edit-profile-data-form .select-element.width', function (e) {
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Width Select', $(this).data('value'));
		});
		$('body').on('click', '.edit-profile-data-form .select-element.birth-month', function (e) {
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Birthday Month Select', $(this).data('value'));
		});
		$('body').on('blur', '.edit-profile-data-form #birthYearText', function (e) {
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Birthday Year Select', $(this).val());
		});
		$('body').on('click', '.edit-profile-data-form .select-element.get-around', function (e) {
			var selection = $(this).find('input').attr('id').replace('getaround_', '');
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Transportation Select', selection);
		});
		$('body').on('click', '.edit-profile-data-form .select-element.interests', function (e) {
			var selection = $(this).find('input').attr('id').replace('interests_', '');
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Product Interest Select', selection);
		});
		$('body').on('click', '.edit-profile-data-form .select-element.where-shop', function (e) {
			var selection = $(this).find('input').attr('id').replace('whereshop_', '');
			pushEvent('eventTracker', 'Personalized Questionnaire', 'Questionnaire Store Select', selection);
		});
	},
	// events that should happen on every page
	all: function () {
		// Main Nav clicks
		$('body').on('click', '.nav-desktop.main-nav ul li a, .nav-mobile.main-nav ul li a:not(.has-children):not(.level-1)', function (e) {
            var link = $(this).attr('href');
            pushEvent('eventTracker', 'Main Nav', 'Link Click', link);
		});

		// Account Sign In
		$('body').on('click', '.login-panel .login-selection', function (e) {
            pushEvent('eventTracker', 'Account Sign In', 'Account Sign In Nav Click', '');
		});
		$('body').on('click', '.login-panel .join-selection', function (e) {
            pushEvent('eventTracker', 'Account Sign In', 'Account Sign Up Nav Click', '');
		});
		$('body').on('click', '.login-panel .login-form .login-submit button', function (e) {
            pushEvent('eventTracker', 'Account Sign In', 'Account Sign In CTA Click', '');
		});
		$('body').on('click', '.login-panel .register-form .login-submit button', function (e) {
            pushEvent('eventTracker', 'Account Sign In', 'Account Sign Up CTA Click', '');
		});
		$('body').on('change', '.login-panel .register-form #add-to-email-list', function (e) {
			if(this.checked) {
				pushEvent('eventTracker', 'Account Sign In', 'Account Join All Emails Select', '');
			}
		});

		// Account Navigation
		$('body').on('click', '.account-dashboard-item a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Dashboard Click', 'Side Nav');
		});
		$('body').on('click', '.dashboard-orders a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Order History Click', 'Dashboard');
		});
		$('body').on('click', '.account-orders-item a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Order History Click', 'Side Nav');
		});
		$('body').on('click', '.dashboard-profile a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Profile Click', 'Dashboard');
		});
		$('body').on('click', '.account-profile-item a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Profile Click', 'Side Nav');
		});
		$('body').on('click', '.dashboard-address a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Addresses Click', 'Dashboard');
		});
		$('body').on('click', '.account-address-item a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Addresses Click', 'Side Nav');
		});
		$('body').on('click', '.dashboard-password a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Password Click', 'Dashboard');
		});
		$('body').on('click', '.account-password-item a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Password Click', 'Side Nav');
		});
		$('body').on('click', '.login-container .flyout-footer a', function (e) {
			pushEvent('eventTracker', 'Account Navigation', 'Account Personalize Your Experience Click', '');
		});

		// Promo Slot click
		$('body').on('click', '.widget-component.image-widget', function (e) {
            pushEvent('eventTracker', 'Promo Slot', 'Text Slider Click', '');
		});
		$('body').on('click', '#zmagsWrapper a', function (e) {
			var link = $(this).attr('href');
            pushEvent('eventTracker', 'Promo Slot', 'Link Click', link);
		});

		// Evergreen links
		$('body').on('click', '.store-finder a.find-a-store', function (e) {
			var link = $(this).attr('href');
            pushEvent('eventTracker', 'Evergreen links', 'Store Click', link);
		});
		$('body').on('click', '.sign-in a', function (e) {
			var link = $(this).attr('href');
            pushEvent('eventTracker', 'Evergreen links', 'Join/Sign In Click', link);
		});
		$('body').on('click', '#Orderstatuslink', function (e) {
			var link = $(this).attr('href');
            pushEvent('eventTracker', 'Evergreen links', 'Order Status Click', link);
		});
		$('body').on('click', '.sign-out a', function (e) {
			var link = $(this).attr('href');
            pushEvent('eventTracker', 'Evergreen links', 'Sign Out Click', link);
		});

		// Logo
		$('body').on('click', '.logo-search-holder a img', function (e) {
            pushEvent('eventTracker', 'Cole Haan Logo', 'Cole Haan Logo Click', window.location.pathname);
		});
		
		// Mini Cart
		$('body').on('click', 'a.minicart-link', function (e) {
            pushEvent('eventTracker', 'Mini Cart', 'Cart Click', '');
		});
		$('body').on('click', '.popover .checkout-and-applepay .checkout-btn', function (e) {
            pushEvent('eventTracker', 'Mini Cart', 'Check Out Click', '');
		});

		// Product Clicks		
		$('body').on('click', '.product-grid .pdp-link a.link', function () {
			var gtmdata = $.parseJSON($(this).attr('data-gtmdata'));
			productClick(gtmdata);
	        pushEvent('eventTracker', 'Grid Features', 'Product Click', gtmdata.stylenumber);
		});
		$('body').on('click', '.product-grid .image-container a:not(.quickview)', function () {
			var gtmdata = $.parseJSON($(this).attr('data-gtmdata'));
			productClick(gtmdata);
	        pushEvent('eventTracker', 'Grid Features', 'Product Click', gtmdata.stylenumber);
		});

		// Grid Features
		$('body').on('click', '.product-tile a.quickview', function () {
			var gtmdata = $.parseJSON($(this).attr('data-gtmdata'));
	        pushEvent('eventTracker', 'Grid Features', 'QuickShop Click', gtmdata.stylenumber);
		});

		// Add to Cart
	    $('body').on('click', '.add-to-cart, .add-to-cart-global', function () {
	        addToCart($.parseJSON($(this).attr('data-gtmdata')), $(this).closest('div').find('.quantity-select').val());
		});

		//Search Bar
		$('.site-search form').submit(function() {
			var q = $('.site-search form .search-field').val();
			pushEvent('eventTracker', 'Search Bar', 'Search Submit', q);
		});
		$('body').on('click', '.suggestions .doyoumean', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Do You Mean?', q);
		});
		$('body').on('click', '.suggestions .do-you-mean', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Do You Mean?', q);
		});
		$('body').on('click', '.suggestions .product-select', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Products Select', q);
		});		
		$('body').on('click', '.suggestions .category-select', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Categories Select', q);
		});		
		$('body').on('click', '.suggestions .recent-select', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Your Recent Searches Select', q);
        });		
		$('body').on('click', '.suggestions .popular-select', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Popular Searches Select', q);
		});		
		$('body').on('click', '.suggestions .content-select', function (e) {
            var q = $('.suggestions').attr('data-query');
            pushEvent('eventTracker', 'Search Bar', 'Content Select', q);
		});
		$('body').on('click', '.footer-links-menu-container a', function (e) {
            var action = $(this).attr('title').replace('Cole Haan ', '') + ' Click';
            pushEvent('eventTracker', 'Social Media', action, window.location.pathname);
		});

		// Desktop Email Pop Up
		$('#emailPopupForm').submit(function() {
			pushEvent('eventTracker', 'Desktop Email Pop Up', 'Email Pop Up Subscribe Click', '');
		});

		// Stay Connected
		$('#footerSignup').submit(function() {
			pushEvent('eventTracker', 'Stay Connected', 'Footer Email Enter', window.location.pathname);
		});
		$('body').on('click', '#emailPopupFormWrapper .btn-close', function() {
			pushEvent('eventTracker', 'Stay Connected', 'Email Pop Up Exit Click', '');
		});
		$('body').on('click', '#emailPopupFormWrapper .create-account', function() {
			pushEvent('eventTracker', 'Stay Connected', 'Create An Account Click', window.location.pathname);
		});
		
	}
};

/**
 * @param {String} productId The product ID
 * @description gets the data for a product click
 */
function productClick (productObject) {
	var obj = {
			'event': 'productClick',
			'ecommerce': {
				'click': {
					'actionField': {'list': 'SearchResults'},
					'products': []
				}
			}
		};
	obj.ecommerce.click.products.push(productObject);
	window.dataLayer.push(obj);// jshint ignore:line
}

/**
 * @param productId
 * @description Click event for add product to cart
 */
function addToCart (productObject, quantity) {
	var quantObj = {'quantity': quantity},
		obj = {
			'event': 'addToCart',
			'ecommerce': {
				'add': {
					'products': []
				}
			}
		};
	obj.ecommerce.add.products.push($.extend(productObject,quantObj));
	window.dataLayer.push(obj);// jshint ignore:line
}

function getAllUrlParams(url) {
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var obj = {};
    if (queryString) {
        queryString = queryString.split('#')[0];
        var arr = queryString.split('&');
        for (var i=0; i<arr.length; i++) {
            var a = arr[i].split('=');
            var paramNum = undefined;
            var paramName = a[0].replace(/\[\d*\]/, function(v) {
                paramNum = v.slice(1,-1);
                return '';
            });
            var paramValue = typeof(a[1])==='undefined' ? true : a[1];
            paramName = paramName.toLowerCase();
            paramValue = paramValue.toLowerCase();
      
            if (obj[paramName]) {
            	if (typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                }
                if (typeof paramNum === 'undefined') {
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName][paramNum] = paramValue;
                }
            } else {
                obj[paramName] = paramValue;
            }
        }
    }

    return obj;
}

/**
 * @function removeFromCart
 * @description Click event for remove product from cart
 */
function removeFromCart (productObject, quantity) {
	var quantObj = {'quantity': quantity},
		obj = {
			'event': 'removeFromCart',
			'ecommerce': {
				'remove': {
					'products': []
				}
			}
		};
	obj.ecommerce.remove.products.push($.extend(productObject,quantObj));
	window.dataLayer.push(obj);// jshint ignore:line
}

/**
 * @function pushEvent
 * @description Convenience method for creating a click event.
 * @param {String} event
 * @param {String} eventCategory
 * @param {String} eventAction
 * @param {String} eventlabel
 */
function pushEvent (event, eventCategory, eventAction, eventLabel) {
	window.dataLayer.push({// jshint ignore:line
		'event': event,
		'eventCategory': eventCategory,
		'eventAction': eventAction,
		'eventLabel': eventLabel
	});
}

/**
 * @function init
 * @description Initialize the tag manager functionality
 * @param {String} nameSpace The current name space
 */
$(document).ready(function () {
	if (pageAction && events[pageAction]) {
		events[pageAction]();
	}
	events.all();
});